// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1xAYw","title":"AfterBackImages_title__3QgOp","images":"AfterBackImages_images__1pWjz"};